import { Div, Span, RefComponentBase, Collection, RefBool, RefString } from "@tblabs/truffle";
import { ControlGroup } from "./ControlGroup";
import { Panel } from "./Panel";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Entry<T> extends Panel
{
    public AddInfo(label: string, value: string)
    {
        this.AddContent(
            new Div("control-group").Append(
                new Span(label),
                new Div().Text(value)
            )
        );

        return this;
    }

    public AddInput(label: string, input: RefComponentBase<any, any>)
    {
        this.AddContent(new ControlGroup(label, input));

        return this;
    }

    public AddField(label: string, field: appendable)
    {
        this.AddContent(
            new Div("control-group").Append(
                new Span(label).FontSize(14).Color("#111827"),
                field
            )
        );

        return this;
    }

    constructor(item: T, collection: Collection<T>, content: appendable[], showControls = true)
    {
        super();

        if (showControls)
        {
            if (collection.CanSwapUp(item))
                this.AddControl("▴", () => collection.SwapUp(item));

            if (collection.CanSwapDown(item))
                this.AddControl("▾", () => collection.SwapDown(item));

            this.AddControl("×", () => collection.Remove(item));

            const expand = new RefBool(false);
            const expandLabel = new RefString("▼");

            this.Content.Append(
                ...content
            ).Visible(expand)

            this.AddControl(expandLabel, () => 
            {
                expand.Toggle();
                expandLabel.value = expand.value ? "▲" : "▼";
            });
        }
    }
}
